export default __webpack_public_path__ + "static/media/help1.390dd57f.png";